<ui-modal [isOpened]="true" modalTitle="Inactivity Warning" size="xl">
  <div class="content">
    <ng-container *ngIf="activityState === 'IDLE'">
      You have been logged out from Hydra due to inactivity.
    </ng-container>
    <ng-container *ngIf="activityState === 'PENDING'">
      You will shortly be logged out from Hydra due to inactivity.
    </ng-container>
  </div>
</ui-modal>
